import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { ClientsTable } from '../components/clients/ClientsTable';
import { ClientsMap } from '../components/clients/ClientsMap';
import { ClientForm } from '../components/clients/ClientForm';
import { clients, Client } from '../data/clients';
import { Plus, List, Map as MapIcon } from 'lucide-react';
type ViewMode = 'table' | 'map';
export function Clients() {
  const [viewMode, setViewMode] = useState<ViewMode>('table');
  const [timePeriod, setTimePeriod] = useState('today');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [clientsList, setClientsList] = useState<Client[]>(clients);
  const handleAddClient = () => {
    setSelectedClient(null);
    setShowForm(true);
  };
  const handleEditClient = (client: Client) => {
    setSelectedClient(client);
    setShowForm(true);
  };
  const handleSaveClient = (client: Client) => {
    if (selectedClient) {
      // Update existing client
      setClientsList(clientsList.map(c => c.id === client.id ? client : c));
    } else {
      // Add new client
      setClientsList([...clientsList, client]);
    }
    setShowForm(false);
    setSelectedClient(null);
  };
  const handleDeleteClient = (clientId: string) => {
    if (confirm('Êtes-vous sûr de vouloir supprimer ce client?')) {
      setClientsList(clientsList.filter(c => c.id !== clientId));
    }
  };
  return <div className="w-full min-h-screen bg-gray-50 flex" data-id="element-732">
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-733" />
      <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`} data-id="element-734">
        <Header onTimePeriodChange={setTimePeriod} currentPeriod={timePeriod} data-id="element-735" />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-736">
          {/* Page Header */}
          <div className="flex items-center justify-between mb-6" data-id="element-737">
            <div data-id="element-738">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-739">
                Gestion des clients
              </h1>
              <p className="text-sm text-gray-600 mt-1" data-id="element-740">
                {clientsList.length} clients actifs
              </p>
            </div>
            <div className="flex items-center space-x-3" data-id="element-741">
              {/* View Mode Toggle */}
              <div className="flex items-center space-x-2 bg-white rounded-lg border border-gray-200 p-1" data-id="element-742">
                <button onClick={() => setViewMode('table')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'table' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-743">
                  <List className="w-4 h-4" data-id="element-744" />
                  <span className="text-sm font-medium" data-id="element-745">Liste</span>
                </button>
                <button onClick={() => setViewMode('map')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'map' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-746">
                  <MapIcon className="w-4 h-4" data-id="element-747" />
                  <span className="text-sm font-medium" data-id="element-748">Carte</span>
                </button>
              </div>
              {/* Add Client Button */}
              <button onClick={handleAddClient} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-749">
                <Plus className="w-4 h-4" data-id="element-750" />
                <span className="text-sm font-medium" data-id="element-751">Nouveau client</span>
              </button>
            </div>
          </div>
          {/* Content */}
          {viewMode === 'table' ? <ClientsTable clients={clientsList} onEdit={handleEditClient} onDelete={handleDeleteClient} data-id="element-752" /> : <ClientsMap clients={clientsList} onEdit={handleEditClient} data-id="element-753" />}
        </main>
      </div>
      {/* Client Form Modal */}
      {showForm && <ClientForm client={selectedClient} onSave={handleSaveClient} onClose={() => {
      setShowForm(false);
      setSelectedClient(null);
    }} data-id="element-754" />}
    </div>;
}